require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-develop-front-end-architecture-service-page.json") })
        }
      }, "path---service-develop-front-end-architecture-service-page");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-develop-front-end-architecture-service-page!./.cache/json/service-develop-front-end-architecture-service-page.json
// module id = 899
// module chunks = 231608221292675